<div class="r184-resumen">
  <div class="r184-resumen__item">
    <span class="r184-resumen__label">Número de miembros</span>
    <strong>{{ data?.miembros?.length | number:'1.0-0' }}</strong>
  </div>
</div>

<ng-template #estadoTpl let-valor let-row="row">
  <span class="r184-estado" [class.r184-estado--error]="valor > 0">
    <mat-icon>{{ valor > 0 ? 'error' : 'check_circle' }}</mat-icon>
    {{ valor > 0 ? valor + (valor === 1 ? ' error' : ' errores') : 'Correcto' }}
  </span>
</ng-template>

<ng-template #origenTpl let-valor let-row="row">
  <span class="r184-origen r184-origen--{{ valor | lowercase }}">
    {{ valor === 'CALCULADO' ? 'Calculado' : valor === 'IMPORTADO' ? 'Importado' : 'Manual' }}
  </span>
</ng-template>

<div class="cf-table-card">
  <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>
</div>
